(() => {
  const form = document.querySelector('[data-hc-filters]');
  if (!form) return;
  const cards = [...document.querySelectorAll('.hc-integrated .hc-product-card')];
  const count = document.querySelector('.hc-integrated .hc-results');
  const empty = document.querySelector('[data-hc-empty]');
  const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const filter = () => {
    const fields = new FormData(form);
    const query = normalize(String(fields.get('q') || '')).trim();
    let visible = 0;
    for (const card of cards) {
      const d = card.dataset;
      const match = (!query || normalize(d.hcTitle).includes(query)) && (!fields.get('language') || fields.get('language') === d.hcLanguage) && (!fields.get('format') || fields.get('format') === d.hcFormat) && (!fields.get('availability') || (fields.get('availability') === 'available') === (d.hcAvailable === 'true'));
      card.hidden = !match;
      if (match) visible++;
    }
    if (count) count.textContent = `${visible} ${visible === 1 ? 'prodotto' : 'prodotti'}`;
    empty.hidden = visible !== 0;
    empty.querySelector('[data-hc-empty-message]').textContent = fields.get('language') === 'jp' ? 'Nessun prodotto giapponese corrisponde a tutti i filtri selezionati. Prova a cambiare formato o disponibilità.' : 'Prova un’altra lingua o un altro formato.';
  };
  form.addEventListener('submit', event => event.preventDefault());
  form.addEventListener('input', filter);
  form.addEventListener('change', filter);
  const reset = () => {
    for (const field of form.querySelectorAll('input, select')) field.value = '';
    filter();
  };
  form.addEventListener('reset', event => { event.preventDefault(); reset(); });
  document.querySelectorAll('[data-hc-reset]').forEach(button => button.addEventListener('click', reset));
  filter();
})();
